module.exports = __webpack_public_path__ + "assets/img/home5.c3c62c04.png";